<div class="sticky-head">
  <app-version-upgrade-header></app-version-upgrade-header>
  <app-global-loading-bar></app-global-loading-bar>

  @if (!isOnline()) {
    <nz-alert
      nzType="error"
      nzMessage="Network Connection Error"
      nzDescription="Please note that any unsaved data may be lost during this offline period."
      nzShowIcon
    ></nz-alert>
  }

  @if (loading) {
    <div class="loading">
      <nz-skeleton [nzActive]="true"></nz-skeleton>
    </div>
  }
</div>
<router-outlet></router-outlet>

<nz-modal
  [nzVisible]="isUpdateModalVisible()"
  nzTitle="Updating..."
  [nzClosable]="false"
  [nzMaskClosable]="false"
  [nzCloseOnNavigation]="false"
  [nzCancelDisabled]="true"
  [nzCancelText]="null"
  [nzOkText]="null"
>
  <ng-container *nzModalContent>
    <div>Updating to the latest version. The website will automatically reload after the update.</div>
  </ng-container>
</nz-modal>
